import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';

export const SubmitButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    marginTop: theme.spacing(10),
  },
}));

export const FormFieldsWrapper = styled.div<{ $hasBody: boolean }>`
  margin-top: ${({ $hasBody }) => ($hasBody ? spacing.space64 : 0)};
`;

export const TextField = styled.span`
  p {
    margin-top: ${spacing.space40} !important;
    margin-bottom: 0 !important;
  }
`;
